import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Header,
  HeaderWrapper,
  MenuContainer,
  MenuList,
  MenuItem,
  ButtonsContainer,
  Link,
  MenuSubItem,
  MenuItemContainer,
  Socials
} from './style';
import theme from '../../../ui/theme';
import { Button, Icon, MenuButton } from '../../../atoms';
import routes from '../../../routes';
import Mosvita from '../../../ui/typography/mosvita';
import { handleClickNavigation } from '../../../utils/common';

const NavBarTablet = ({
  current_path,
  menu,
  signup,
  signin,
  socials,
  mediaIsPhone
}) => {
  const [menuIsOpen, setMenuIsOpen] = useState(false);
  const [openSubMenu, setOpenSubMenu] = useState();

  const isPrimary = current_path === routes.home.path || menuIsOpen;

  const handleOnClickMenuItem = (menu_item, submenu = false) => {
    const {
      button: { uri, title },
      items
    } = menu_item;
    if ((!items && uri.length > 0) || submenu) {
      handleClickNavigation(uri);
      setMenuIsOpen(false);
      setOpenSubMenu('');
    } else {
      setOpenSubMenu(title);
    }
  };

  const onClickLogo = () => {
    handleClickNavigation(routes.home.path);
    setMenuIsOpen(false);
  };

  return (
    <Header className={isPrimary ? 'home-bg' : ''}>
      <HeaderWrapper>
        <Icon
          type="icon-logo-tm"
          size={38}
          color={theme.colors.white}
          onClick={onClickLogo}
        />
        <MenuButton
          isOpen={menuIsOpen}
          onClick={() => setMenuIsOpen(!menuIsOpen)}
        />
        <MenuContainer isOpen={menuIsOpen}>
          <MenuList>
            {menu &&
              menu.map((item, i) => (
                <MenuItemContainer key={`MenuItemContainer-${i}`}>
                  <MenuItem onClick={() => handleOnClickMenuItem(item)}>
                    <Mosvita htmlAttribute="span" type="menuHeader">
                      {item.button.title}
                    </Mosvita>
                  </MenuItem>
                  {!!item.items &&
                    openSubMenu === item.button.title &&
                    [...item.items].map((subitem, index) => (
                      <MenuSubItem
                        key={`subitem-${i}-${index}`}
                        onClick={() =>
                          handleOnClickMenuItem(subitem.data, true)
                        }
                      >
                        <Mosvita htmlAttribute="span" type="subMenuTablet">
                          {subitem.data.button.title}
                        </Mosvita>
                      </MenuSubItem>
                    ))}
                </MenuItemContainer>
              ))}
          </MenuList>
          <ButtonsContainer>
            {socials && (
              <Socials>
                {Object.keys(socials).map(i => (
                  <Icon
                    onClick={() => handleClickNavigation(socials[i].uri)}
                    size={30}
                    type={`icon-${socials[i].title}`}
                    key={`socials-${i}`}
                  />
                ))}
              </Socials>
            )}
            {signup && Object.keys(signup).length > 0 && (
              <Button
                onClick={() => handleClickNavigation(signup.uri)}
                minHeight={40}
                minWidth={mediaIsPhone ? 260 : 552}
                btnType={Button.TYPE.PRIMARY}
                btnText={signup.title}
              />
            )}
            {signin && (
              <Link target="_blank" href={signin.uri}>
                <Mosvita type="menuHeader" htmlAttribute="span">
                  {signin.title}
                </Mosvita>
              </Link>
            )}
          </ButtonsContainer>
        </MenuContainer>
      </HeaderWrapper>
    </Header>
  );
};

NavBarTablet.propTypes = {
  current_path: PropTypes.string.isRequired,
  menu: PropTypes.array,
  signup: PropTypes.object,
  signin: PropTypes.object.isRequired,
  socials: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  mediaIsPhone: PropTypes.bool.isRequired
};

export default NavBarTablet;
